import { useNavigate } from 'react-router-dom';
import {
  AccountPageCard,
  AccountPageCardBody,
  AccountPageCardTitle,
  AccountPageLayout,
  AccountPagePrimaryButton,
  AccountPageSectionLabel,
} from '../components/styled';
import { useAuth } from '../context/AuthContext';

function AccountPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const expiresAtLabel = user?.expiresAt
    ? new Date(user.expiresAt).toLocaleString()
    : 'Unavailable';

  const handleLogout = () => {
    navigate('/logout');
  };

  return (
    <AccountPageLayout>
      <AccountPageCard>
        <AccountPageSectionLabel>Profile</AccountPageSectionLabel>
        <AccountPageCardTitle>
          {user?.username || 'Authenticated user'}
        </AccountPageCardTitle>
        <AccountPageCardBody>{user?.email || 'No email loaded'}</AccountPageCardBody>
        <AccountPageCardBody>Role: {user?.role || 'Unavailable'}</AccountPageCardBody>
        <AccountPageCardBody>User ID: {user?.userId || 'Unavailable'}</AccountPageCardBody>
        <AccountPageCardBody>
          Token expiration: {expiresAtLabel}
        </AccountPageCardBody>
      </AccountPageCard>

      <AccountPagePrimaryButton onClick={handleLogout}>
        Sign Out
      </AccountPagePrimaryButton>
    </AccountPageLayout>
  );
}

export default AccountPage;
